import React from "react";
import { observer } from "mobx-react-lite";
import {
  Box,
  HStack,
  Icon,
  Popover,
  Portal,
  Separator,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useStores } from "../../shared/stores/RootStore";
import { Link } from "react-router-dom";
import { appRoutes } from "../../../App";
import { ArrowForwardIcon } from "../../shared/views/icons";

const SurveyMapSelectionPopoverBase: React.FC = () => {
  const { surveyStore } = useStores();

  if (surveyStore.mapSelection === undefined) return null;

  return (
    <Popover.Root
      size={"sm"}
      modal
      lazyMount
      unmountOnExit
      open
      onOpenChange={({ open }) => {
        if (!open) {
          surveyStore.clearMapSelection();
        }
      }}
      positioning={{
        offset: {
          mainAxis: 14,
        },
      }}
    >
      <Popover.Trigger asChild>
        {surveyStore.mapSelection && (
          <Box
            position={"absolute"}
            left={surveyStore.mapSelection.x}
            top={surveyStore.mapSelection.y}
          ></Box>
        )}
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content>
            <Popover.Arrow />
            <Popover.CloseTrigger />
            <Stack separator={<Separator />} gap={0} overflow={"auto"}>
              {surveyStore.mapSelection.surveys.map((p) => (
                <Link
                  key={p.id}
                  to={appRoutes.survey(p.id)}
                  onClick={() => surveyStore.clearMapSelection()}
                >
                  <HStack
                    py={2}
                    px={2}
                    _hover={{
                      textDecor: "underline",
                    }}
                  >
                    <Stack flexGrow={1} gap={0}>
                      <Text
                        fontWeight={"semibold"}
                        textTransform={"uppercase"}
                        fontSize="2xs"
                        opacity={0.6}
                      >
                        {p.city}
                      </Text>
                      <Text>{p.name}</Text>
                    </Stack>

                    <Icon as={ArrowForwardIcon} color="primary.600" />
                  </HStack>
                </Link>
              ))}
            </Stack>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};

export const SurveyMapSelectionPopover = observer(
  SurveyMapSelectionPopoverBase,
);
